<template>
    <div class="container">
        <br />
        <h1>Loading...</h1>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, watch } from 'vue'

    import { useStartupDetailsQueryV1 } from '@Organizations/Users/queries-vue-composables'

    const { runStartupDetailsQueryV1,
        modelStartupDetailsQueryV1: startupDetails } = useStartupDetailsQueryV1();

    onMounted(() =>
    {
        runStartupDetailsQueryV1()
    })

    watch(startupDetails, (details) =>
    {
        if (details?.Url)
        {
            location.href = details.Url
        }
    })
</script>
